<script>
    export let value = null
    export let label = null
    export let required = false
    export let disabled = false
    export let validation = null
    export let errorMsg = null
    export let name = null
    export let valid = null
    export let placeholder = ''
    export let info = null
    export let maxLength = 0
    export let quiet = false
    export let prefix = ''
    export let suffix = ''
    export let transform = v => v
    let focus
    import { Typography } from './'
    import { getContext, onDestroy } from 'svelte'
    import { AlertCircle, CheckMarkCircle, InfoOutline } from '../Icons'
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    function onchange() {
        dispatch('change', {})
    }
    function onkeypress(e) {
        dispatch('keypress', { eventTarget: e })
    }
    function onkeyup(e) {
        dispatch('keyup', { eventTarget: e })
    }
    function onblur(e) {
        value = e.target.value.replace(/\s+$/g, '')
        dispatch('blur', {})
    }
    let formData = getContext('formData')
    // @ts-ignore
    $: if (value && validation) {
        // @ts-ignore
        valid = value && validation ? validation(value) : null
    }
    // @ts-ignore
    $: if (((value && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid: !!valid,
                            validation: !!validation,
                            required,
                            value,
                            label,
                        },
                    ],
                ])
            )
        })
    onDestroy((_) => {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
    // @ts-ignore
    $: if (value && maxLength) {
        value = value.slice(0, maxLength)
    }
    // @ts-ignore
    $: if (value && typeof value === 'string') {
        value = transform(value.replace(/^\s+/g, ''))
    }
    // $: if(required && !validation) {
    //   valid = true;
    // }
</script>

<div class={quiet ? 'quiet' : 'box'} class:disabled>
    {#if label}
        <label for={name}>
            <div class="label_container">
                <Typography
                    style="margin: 0 0 0 0;"
                    type="caption"
                    color={quiet ? 'grey-800' : disabled ? 'grey-300' : 'black'}
                    >{label}</Typography
                >
                {#if required && !disabled && !value}
                    <InfoOutline
                        size={16}
                        title="Campo requerido"
                        style="cursor: pointer"
                    />
                {/if}
            </div>
        </label>
    {/if}
    <div class="input_container">
        {#if prefix}
            <i class="alter" class:disabled>{prefix}</i>
        {/if}
        <input
            id={name}
            type="text"
            on:change={onchange}
            on:keypress={onkeypress}
            on:keyup={onkeyup}
            on:blur={onblur}
            on:focus={(_) => (focus = true)}
            on:blur={(_) => (focus = false)}
            {name}
            {disabled}
            {placeholder}
            bind:value
        />
        {#if suffix}
            <i class="alter suffix" class:disabled>{suffix}</i>
        {/if}
        {#if (!!quiet && !disabled) || !quiet}
            {#if value && validation && !disabled}
                {#if valid}
                    <CheckMarkCircle
                        style="margin-bottom: 11px;"
                        color="#7ED321"
                    />
                {:else}
                    <AlertCircle style="margin-bottom: 11px;" color="#E9573D" />
                {/if}
            {/if}
        {/if}
    </div>
    <span
        class={!valid && validation && value && !disabled
            ? 'error'
            : focus
              ? 'focus'
              : ''}
        style={quiet
            ? 'display: none'
            : (!valid && errorMsg && !disabled) || info
              ? !valid
                  ? 'padding: 11px 0;'
                  : 'padding: 0'
              : ''}
    >
        {#if value && validation && !valid && errorMsg && !disabled}
            <Typography type="label" style="margin: 0">{errorMsg}</Typography>
        {:else if info && !disabled}
            <Typography type="caption" color="grey-300" style="margin: 0"
                >{info}</Typography
            >
        {/if}
    </span>
</div>

<style>
    .box,
    .quiet {
        width: 100%;
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        user-select: none;
    }

    .label_container {
        position: relative;
        display: flex;
        gap: 7px;
        align-items: center;
        margin-bottom: 16px;
    }

    .quiet .label_container {
        margin-bottom: 6px;
    }
    .input_container {
        height: 33px;
        position: relative;
        display: flex;
        gap: 12px;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .quiet input[type='text']:disabled {
        color: var(--color-black) !important;
        opacity: 1;
    }
    input[type='text'] {
        background: transparent;
        padding: 0 0 11px 0;
        border-style: none;
        margin: 0;
        font-size: 17px;
        width: calc(100% - 0px);
        line-height: 22px;
        color: var(--color-black);
        outline: none;
        caret-color: #5496e3;
    }
    input[type='text']::placeholder {
        color: var(--color-grey-300);
    }
    input[type='text']:disabled {
        cursor: no-drop;
    }
    span {
        width: 100%;
        border-top: 1px var(--color-grey-300) solid;
        display: flex;
    }

    span.focus {
        /* border-top: 1px var(--color-grey-800) solid; */
        border-color: var(--color-grey-800);
    }

    .error {
        border-color: var(--color-accent-alert-error);
        /* border-top: 1px var(--color-accent-alert-error) solid; */
        color: var(--color-accent-alert-error);
        background: var(--color-accent-alert-error-bg);
        border-radius: 0 0 8px 8px;
    }

    .disabled {
        cursor: no-drop;
    }

    .disabled span {
        border-top: 1px var(--color-grey-300) solid;
    }

    .disabled input[type='text']:disabled {
        color: var(--color-grey-400);
    }
    input:-webkit-autofill {
        box-shadow: 0 0 0 100px white inset;
    }
    .alter {
        height: 100%;
        font-size: 17px;
        width: auto;
        color: var(--color-grey-800);
        font-style: normal;
        font-weight: 500;
        position: relative;
        padding: 0 0 0 0px;
        margin: 0;
        display: flex;
        margin: auto;
    }

    .disabled {
        color: var(--color-grey-400);
    }

    .suffix {
        padding: 0 10px 0 0;
    }
</style>
